module.exports = __webpack_public_path__ + "img/market.c6ca5961.svg";